let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lGwXm")).then(() => parcelRequire('iQybw'));